import React from "react";
import Marquee from "react-fast-marquee";
import { TID } from "@/lib/testIds";
import { useT } from "@/lib/i18n";

const Item = ({ outline, children }) => (
    <span
        className={`font-serif text-[13vw] md:text-[9vw] leading-none tracking-[-0.02em] ${
            outline ? "marquee-outline text-sn-ink" : "text-sn-ink"
        } px-6`}
    >
        {children}
    </span>
);

const Star = () => (
    <span className="inline-flex items-center justify-center w-16 md:w-24 text-sn-blue">
        <svg viewBox="0 0 24 24" className="w-8 h-8 md:w-12 md:h-12" fill="currentColor">
            <path d="M12 2l2.4 6.9L22 10l-5.6 4.6L18 22l-6-3.7L6 22l1.6-7.4L2 10l7.6-1.1z" />
        </svg>
    </span>
);

export default function EditorialMarquee() {
    const { t, lang } = useT();
    const items = t("marquee") || [];
    return (
        <section data-testid={TID.marquee} className="bg-sn-paper py-16 md:py-24 overflow-hidden">
            <Marquee key={lang} gradient={false} speed={38} pauseOnHover autoFill>
                {items.map((txt, i) => (
                    <React.Fragment key={i}>
                        <Item outline={i % 2 === 1}>{txt}</Item>
                        <Star />
                    </React.Fragment>
                ))}
            </Marquee>
        </section>
    );
}
